/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartTrendXyUpIcon32Regular = forwardRef('DataChartTrendXyUpIcon32Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 32 }, props),
        React.createElement("path", { d: "M5 5a1 1 0 0 0-2 0v18.5A4.5 4.5 0 0 0 7.5 28H28a1 1 0 1 0 0-2H7.5A2.5 2.5 0 0 1 5 23.5V5Z" }),
        React.createElement("path", { d: "M27.707 9.707a1 1 0 0 0-1.414-1.414L18.5 16.086l-3.69-3.69a1.5 1.5 0 0 0-2.12 0l-4.897 4.897a1 1 0 1 0 1.414 1.414l4.543-4.543 3.69 3.69a1.5 1.5 0 0 0 2.12 0l8.147-8.147Z" })));
});
